import React, { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import ReactPhoneInput from 'react-phone-input-2';
import { StyledPhoneInputLabel, StyledErrorWrapper, Error } from '../styles';
import useDefaultConfig from './hooks/useDefaultConfig';

const ReactHookPhoneInput = ({ name, control, defaultValue, placeholder, errors, setSelectedCountry, setValue }) => {
  const { defaultCountry, error, inputDefaultValue, locale } = useDefaultConfig({
    errors,
    defaultValue,
    name,
  });

  const handleOnChange = (value, country, field) => {
    field.onChange(value);
    setSelectedCountry(country);
  };

  const [specialLabel, setSpecialLabel] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  // validates the phone input value after the first render if it's not an empty string
  useEffect(() => {
    if (defaultValue !== '') setValue(name, defaultValue, { shouldValidate: true });
  }, []);

  // set specialLabel based on input focus state
  useEffect(() => {
    setSpecialLabel(isFocused || error ? placeholder : '');
  }, [isFocused]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={inputDefaultValue}
      render={({ field }) => (
        <StyledPhoneInputLabel>
          <ReactPhoneInput
            {...field}
            specialLabel={specialLabel}
            value={inputDefaultValue}
            placeholder={placeholder}
            countryCodeEditable={false}
            inputProps={{
              required: true,
              id: name,
            }}
            country={defaultCountry}
            containerClass={error ? 'input-error' : ''}
            localization={locale}
            enableSearch
            disableSearchIcon
            disableCountryGuess
            enableLongNumbers
            onChange={(value, country) => handleOnChange(value, country, field)}
            onFocus={() => setIsFocused(true)}
            onBlur={(...event) => {
              setIsFocused(false);
              field.onBlur(event);
            }}
          />
          <StyledErrorWrapper>
            {!!error && (
              <Error component="p" variant="DS_copySmallRegular">
                {error?.message || 'Field is not valid.'}
              </Error>
            )}
          </StyledErrorWrapper>
        </StyledPhoneInputLabel>
      )}
    />
  );
};

export default ReactHookPhoneInput;
